import { useRuntimeConfig } from 'nuxt/app'
import type { RouteLocationNormalized } from 'vue-router'
import { sanitize } from './sanitize'

interface HeaderOptions {
  to: RouteLocationNormalized
  xkey?: string | null
}

export function getHttpHeaders(options: HeaderOptions) {
  const runtimeConfig = useRuntimeConfig()
  const { to, xkey = null } = options

  const isPriceRequest = 'arrive' in to.query
  const cacheTime = isPriceRequest
    ? runtimeConfig.priceCacheTime
    : runtimeConfig.nonPriceCacheTime
  const graceTime = isPriceRequest
    ? runtimeConfig.priceGraceTime
    : runtimeConfig.nonPriceGraceTime

  const headers = {
    'Cache-Control': `max-age=${cacheTime}, public`,
    Grace: `${graceTime}`,
  }

  // Add xkey if provided or if there's a slug in route params
  if (xkey || to.params.slug) {
    headers.xkey = `${sanitize(xkey || (to.params.slug as string))}`
  }

  return headers
}
